module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-RegularItalic-WebM-f596573e4541780e9dab03cb5fa29f33.woff2";